import { render, staticRenderFns } from "./voorwie.vue?vue&type=template&id=a54bfe48&scoped=true&"
import script from "./voorwie.vue?vue&type=script&lang=ts&"
export * from "./voorwie.vue?vue&type=script&lang=ts&"
import style0 from "./voorwie.vue?vue&type=style&index=0&id=a54bfe48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54bfe48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
